<template>
  <div class="mb-4">
    <v-card elevation="0" style="border: 1px solid #eee; border-radius: 10px; position: relative">
      <v-card-text>
        <v-layout wrap class="form-control">
          <v-flex xs3 px-2>
            <div class="caption">ชื่อ-นามสกุล</div>
            <input v-model="filterInput.name" type="text" placeholder="ชื่อจริง" />
          </v-flex>
          <v-flex xs3 px-2>
            <div class="caption">อายุ</div>
            <input v-model="filterInput.age" type="text" placeholder="อายุ" />
          </v-flex>
          <v-flex xs3 px-2>
            <div class="caption">เพศ</div>
            <multiselect
              v-model="filterInput.gender"
              :options="genderOptions"
              label="label"
              select-label
              selected-label
              track-by="value"
            ></multiselect>
          </v-flex>
          <v-flex xs3 px-2>
            <div class="caption">ระดับความเสี่ยง</div>
            <multiselect
              v-model="filterInput.risk"
              :options="riskLevelOptions"
              select-label
              selected-label
              label="label"
              track-by="value"
            ></multiselect>
          </v-flex>
          <v-flex xs3 px-2>
            <div class="caption">สถานะ</div>
            <multiselect
              v-model="filterInput.status"
              :options="statusOptions"
              select-label
              selected-label
              label="label"
              track-by="value"
            ></multiselect>
          </v-flex>
          <v-flex xs3 px-2>
            <div class="caption">เบอร์โทร</div>
            <input v-model="filterInput.phone_no" type="text" placeholder="ชื่อจริง" />
          </v-flex>

          <v-flex xs3 px-2>
            <div class="caption">วันที่เริ่มต้น</div>
            <DatepickerCustomDialog v-model="filterInput.date_from" :allowed-dates="allowedDates">
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.date_from)"
                placeholder="เลือกวันที่เริ่มต้น"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs3 px-2>
            <div class="caption">วันที่สิ้นสุด</div>
            <DatepickerCustomDialog v-model="filterInput.date_to" :allowed-dates="allowedDates">
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.date_to)"
                placeholder="เลือกวันที่สิ้นสุด"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed color="primary" @click="handleSearch">
              <em class="fas fa-search mr-1" />
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime.js'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    DatepickerCustomDialog,
    Multiselect
  },
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filterInput: {
        name: '',
        age: '',
        gender: '',
        risk: '',
        status: '',
        phone_no: '',
        date_from: '',
        date_to: ''
      },
      genderOptions: [
        {
          label: 'ชาย',
          value: 'male'
        },
        {
          label: 'หญิง',
          value: 'female'
        }
      ],
      riskLevelOptions: [
        {
          label: 'ความเสี่ยงต่ำ',
          value: 'low'
        },
        {
          label: 'ความเสี่ยงปานกลาง',
          value: 'medium'
        },
        {
          label: 'ความเสี่ยงสูง',
          value: 'high'
        }
      ],
      statusOptions: [
        {
          label: 'ยังไม่ได้ดำเนินการ',
          value: 'not_processed'
        },
        {
          label: 'รอติดต่อกลับ',
          value: 'waiting'
        },
        {
          label: 'ติดต่อแล้ว',
          value: 'contacted'
        }
      ]
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.handleInit()
      }
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      if (this.filters) {
        this.filterInput.name = this.filters.name
        this.filterInput.age = this.filters.age
        this.filterInput.gender = this.filters.gender
          ? this.genderOptions.find((item) => item.value === this.filters.gender)
          : ''
        this.filterInput.risk = this.filters.risk
          ? this.riskLevelOptions.find((item) => item.value === this.filters.risk)
          : ''
        this.filterInput.status = this.filters.status
          ? this.statusOptions.find((item) => item.value === this.filters.status)
          : ''
        this.filterInput.phone_no = this.filters.phone_no
        this.filterInput.date_from = this.filters.date_from
        this.filterInput.date_to = this.filters.date_to
      }
    },
    handleSearch() {
      const tempFilters = {}
      Object.keys(this.filterInput).forEach((key) => {
        if (this.filterInput[key] !== '') {
          if (['risk', 'status', 'gender'].includes(key)) {
            Object.assign(tempFilters, { [key]: this.filterInput[key].value })
          } else {
            Object.assign(tempFilters, { [key]: this.filterInput[key] })
          }
        }
      })

      this.$emit('onSearch', tempFilters)
    },
    handleClearSearch() {
      this.$emit('onClearSearch')
    },
    handleGetDateFormatted(value) {
      return value ? dayjs(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    allowedDates(val) {
      return dayjs().diff(val, 'hour', true) > 0
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/AdvanceSearch.vue